
import { useState, useEffect } from "react";

const useMediaQuery = (maxWidth) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);

    const handleResize = () => {
      setMatches(mediaQuery.matches);
    };

    handleResize(); // Check on mount

    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, [maxWidth]);

  return matches;
};

export default useMediaQuery;

